import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PricingTable from "../components/hamdeliTable"
import PricingFold from "../components/hamdeliFold"
import PricingQa from "../components/pricingQa"
import LastCall from "../components/homeLastCall"
import {
  FoldContainer,
  FoldSection,
  IframeContainer,
} from "../components/hamdeliFold/styled"

const SecondPage = () => (
  <Layout>
    <SEO slug="/hamdeli" />
    <IframeContainer>
      <iframe
        src="https://www.aparat.com/video/video/embed/videohash/cmyBu/vt/frame"
        allowFullScreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        frameborder="0"
      ></iframe>
    </IframeContainer>
    <FoldContainer direction="vertical" tablet={{ direction: "horizontal" }}>
      <FoldSection width="100%" tablet={{ width: "60%" }}>
        <PricingFold />
      </FoldSection>
      <FoldSection width="100%" tablet={{ width: "40%" }}>
        <PricingTable width="100%" />
      </FoldSection>
    </FoldContainer>
    <PricingQa />
    <LastCall />
  </Layout>
)

export default SecondPage
